import { EventsFilterForm } from './EventsFilterForm';

export { EventsFilterForm };
export default EventsFilterForm;
